module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0081.jpg?v=6f58d871";